export default __webpack_public_path__ + "media/zurb/img/experience-design/experience_framework-d62e60f18e08dc3e8f0f8f3cc4629778.png";